<template>
  <sui-modal size="small" v-model="visible" animation="drop" :closable="false">
    <sui-modal-header>
      Create ticket
    </sui-modal-header>
    <sui-modal-content>
      <sui-form @submit.prevent="submit()">
        <sui-form-fields>
          <sui-form-field :width="8">
            <label>Your name</label>
            <sui-input v-model.trim="name" />
          </sui-form-field>
          <sui-form-field :width="8" required>
            <label>Your email</label>
            <sui-input v-model.trim="email" disabled readonly tabindex="-1" />
          </sui-form-field>
        </sui-form-fields>
        <sui-form-field required>
          <label>Subject</label>
          <sui-input v-model.trim="subject" />
        </sui-form-field>
        <sui-form-field required>
          <label>Issue</label>
          <div class="ui input">
            <textarea v-model.trim="text" />
          </div>
          <small>
            Steps to reproduce. What is expected? What is actually happening?
          </small>
        </sui-form-field>
        <sui-form-fields>
          <sui-form-field :width="8">
            <label>Service</label>
            <sui-dropdown search selection v-model="serviceId" :options="servicesList" />
          </sui-form-field>
          <sui-form-field :width="8">
            <label>Host</label>
            <sui-dropdown search selection v-model="hostId" :options="hostsList" />
          </sui-form-field>
        </sui-form-fields>
      </sui-form>
      <sui-message error v-if="error">
        {{error}}
      </sui-message>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button color="green" @click="submit()">Send</sui-button>
        <sui-button color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Got it!<br>
        We will send an answer to your email.
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import api from '@/api'

  export default {
    name: 'ModalSupport',
    data() {
      return {
        visible: false,
        error: null,
        success: null,
        name: '',
        email: '',
        subject: '',
        text: '',
        serviceId: null,
        hostId: null,
      }
    },
    computed: {
      ...mapGetters(['services', 'hosts', 'account', 'user', 'tariff', 'servicesById', 'hostsById']),
      servicesList() {
        return this.services.map(service => {
          return {
            value: service.id,
            image: {src: service._logo},
            text: service.name,
          }
        })
      },
      hostsList() {
        return this.hosts.map(host => {
          return {
            value: host.id,
            image: {src: host._logo},
            text: host.name,
          }
        })
      },
    },
    watch: {
      visible(visible) {
        if (visible) {
          this.email = this.user.email
          setTimeout(() => {
            this.$el.querySelector('input').select()
          }, 500)
        } else {
          this.reset()
        }
      }
    },
    methods: {
      open() {
        this.visible = true
      },
      close() {
        this.visible = false
        this.reset()
      },
      reset() {
        this.error = null
        this.success = null
        this.subject = ''
        this.text = ''
        this.serviceId = null
        this.hostId = null
      },
      submit() {
        this.error = null
        if (this.subject && this.text) {
          const service = this.servicesById[this.serviceId]
          const host = this.hostsById[this.hostId]
          let text = `Account: ${this.account.id} (${this.tariff.name})\n`
          if (service) {
            text += `Service: ${service.name} (${service.type})\n`
          }
          if (host) {
            text += `Host: ${host.name} (${host.providerType})\n\n`
          }
          text += `Issue:\n${this.text}`
          api.support({
            name: this.name,
            email: this.email,
            subject: this.subject,
            text: text,
          }).then(() => {
            this.success = true
            setTimeout(() => {
              this.close()
            }, 2000)
          }).catch(error => {
            this.error = error
          })
        } else {
          this.error = 'Please, fill Subject and Issue before sending.'
        }
      },
      cancel() {
        this.close()
      },
    },
    created() {
      this.$modals.support = this
    },
  }
</script>
